var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalCardDesign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 180,
    viewBox: "0 0 285 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_18250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.415 179.566L284.415 0.760773L0.983726 0.760785L0.983734 179.566L284.415 179.566Z",
    fill: "#3E507A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_18250"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.984131,
    y: 179.566,
    width: 178.805,
    height: 283.431,
    rx: 9.73089,
    transform: "rotate(-90 0.984131 179.566)",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalCardDesign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ExternalCardDesign.5e70241fcdcccefec6e66de0069deeb7.svg";